import React from 'react'
import {
  LockClosedIcon,
  ClockIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline'
import { BookmarkedUrl } from '@/types/bookmark'
import { formatDate, formatDateTime } from '../../../shared/lib/format'

interface SecurityBadgesProps {
  url: BookmarkedUrl
  className?: string
}

// 보안 배지 컴포넌트 (비밀번호 설정, 만료기간 표시)
const SecurityBadges: React.FC<SecurityBadgesProps> = ({
  url,
  className = '',
}) => {
  // 비밀번호 보호 여부 확인 - 여러 방법으로 체크
  const hasPassword = Boolean(
    url.hasPassword ||
      url.security?.hasPassword ||
      (url.password && url.password !== '')
  )

  const hasExpiration = Boolean(url.expiresAt || url.security?.expiresAt)
  const expirationDate = url.expiresAt || url.security?.expiresAt

  const isExpired = hasExpiration && new Date(expirationDate!) <= new Date()
  const isExpiringSoon =
    hasExpiration &&
    !isExpired &&
    new Date(expirationDate!).getTime() - new Date().getTime() <
      24 * 60 * 60 * 1000 // 24시간 이내

  if (!hasPassword && !hasExpiration) {
    return null
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* 비밀번호 보호 배지 */}
      {hasPassword && (
        <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-1 text-xs font-medium text-blue-800 dark:bg-blue-900/20 dark:text-blue-400">
          <LockClosedIcon className="mr-1 h-3 w-3" />
          비밀번호 보호
        </span>
      )}

      {/* 만료기간 배지 */}
      {hasExpiration && (
        <span
          className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${
            isExpired
              ? 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-400'
              : isExpiringSoon
                ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-400'
                : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
          }`}
          title={`만료일: ${formatDateTime(expirationDate)}`}
        >
          {isExpired ? (
            <ExclamationTriangleIcon className="mr-1 h-3 w-3" />
          ) : (
            <ClockIcon className="mr-1 h-3 w-3" />
          )}
          {isExpired
            ? '만료됨'
            : isExpiringSoon
              ? '곧 만료'
              : formatDate(expirationDate)}
        </span>
      )}
    </div>
  )
}

export default SecurityBadges
